import { type DeepiToastProps } from '@deepidoo/deesplay-shared/components/toast/DeepiToast.vue';

export const toastMessages = {
	success: {
		passwordUpdated: {
			title: 'core.components.toast.success.password-updated.title',
			text: 'core.components.toast.success.password-updated.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		},
		emailSent: {
			title: 'core.components.toast.success.email-sent.title',
			text: 'core.components.toast.success.email-sent.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		},
		passwordReset: {
			title: 'core.components.toast.success.password-reset.title',
			text: 'core.components.toast.success.password-reset.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		},
		messageOrdered: {
			title: 'core.components.toast.success.message-ordered.title',
			text: 'core.components.toast.success.message-ordered.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		}
	},
	warning: {
		networkSlow: {
			title: 'core.components.toast.warning.network-slow.title',
			text: 'core.components.toast.warning.network-slow.text',
			color: 'warning',
			icon: 'icon-warning',
			timeout: 5000
		}
	},
	error: {
		badRequest: {
			title: 'core.components.toast.error.bad-request.title',
			text: 'core.components.toast.error.bad-request.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		forbidden: {
			title: 'core.components.toast.error.forbiden.title',
			text: 'core.components.toast.error.forbiden.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		notFound: {
			title: 'core.components.toast.error.not-found.title',
			text: 'core.components.toast.error.not-found.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		serverError: {
			title: 'core.components.toast.error.server-error.title',
			text: 'core.components.toast.error.server-error.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		gatewayError: {
			title: 'core.components.toast.error.gateway-error.title',
			text: 'core.components.toast.error.gateway-error.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		cloudPickerError: {
			title: 'core.components.toast.error.cloud-picker-error.title',
			text: 'core.components.toast.error.cloud-picker-error.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		}
	}
} satisfies Record<string, Record<string, DeepiToastProps>>;

export type ToastCategory = keyof typeof toastMessages;
export type ToastKey<T extends ToastCategory> = keyof typeof toastMessages[T];